import { render } from "./PageSearchItem.vue?vue&type=template&id=22bb7738"
import script from "./PageSearchItem.vue?vue&type=script&lang=js"
export * from "./PageSearchItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiPaper/Components/PageSearchItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22bb7738"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22bb7738', __exports__)) {
    api.reload('22bb7738', __exports__)
  }
  
  module.hot.accept("./PageSearchItem.vue?vue&type=template&id=22bb7738", () => {
    api.rerender('22bb7738', render)
  })

}


export default __exports__